import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';

import SystemMessage from './SystemMessage';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./system-message.i18n.json'));

type Props = {
  text: string,
  time: string,
  campaignId: number,
  subcampaignId: number,
  deliverableId: number,
  isBrand: boolean
};

class SystemChatMessageDeliverableDetailsUpdated extends SystemMessage<Props> {
  render(): React.ReactNode {
    const { text, campaignId, subcampaignId, deliverableId, isBrand } = this.props;

    return (
      <React.Fragment>
        <div className="messages-system-message__container">
          <div className="messages-system-message__bubble">
            { text }
            <div>
              <ActionButton
                color="tertiary"
                height="minimum"
                link={`/campaigns/${campaignId}/${isBrand ? 'subcampaigns' : 'details'}/${subcampaignId}#deliverable-${deliverableId}`}
              >
                {__t('system_message.view_deliverable')}
              </ActionButton>
            </div>
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageDeliverableDetailsUpdated;
